import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

export interface ToolInvocationData {
  state: string;
  toolName?: string;
  toolCallId?: string;
  args?: Record<string, unknown>;
  result?: unknown;
}

interface ToolInvocationAccordionProps {
  inv: ToolInvocationData;
}

function toolDisplayName(toolName?: string): string {
  if (!toolName) return "tool";
  const names: Record<string, string> = {
    list_files: "Dateien auflisten",
    read_file: "Datei lesen",
    write_file: "Datei schreiben",
  };
  return names[toolName] ?? toolName;
}

export function ToolInvocationAccordion({ inv }: ToolInvocationAccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  const hasArgs = inv.args != null && Object.keys(inv.args).length > 0;
  const hasResult = inv.result !== undefined;
  const hasContent = hasArgs || hasResult;

  return (
    <div className="mt-2 rounded border bg-light text-dark small">
      <button
        type="button"
        className="d-flex align-items-center justify-content-between w-100 p-2 border-0 rounded bg-light text-dark text-start small"
        onClick={() => hasContent && setIsOpen((o) => !o)}
        aria-expanded={isOpen}
        aria-controls={`tool-inv-${inv.toolCallId ?? inv.toolName ?? "tool"}`}
      >
        <strong>{toolDisplayName(inv.toolName)}</strong>
        {hasContent && (
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} className="text-muted" />
        )}
      </button>
      {hasContent && isOpen && (
        <div id={`tool-inv-${inv.toolCallId ?? inv.toolName ?? "tool"}`} className="px-2 pb-2">
          {hasArgs && (
            <>
              <div className="small fw-semibold text-muted mt-2 mb-1">Parameter</div>
              <pre className="mt-0 overflow-auto rounded bg-white text-dark p-2 mb-2 small border">
                {JSON.stringify(inv.args, null, 2)}
              </pre>
            </>
          )}
          {hasResult && (
            <>
              <div className="small fw-semibold text-muted mt-1 mb-1">Ergebnis</div>
              <pre className="mt-0 max-h-32 overflow-auto rounded bg-white text-dark p-2 mb-0 small border">
                {typeof inv.result === "string"
                  ? inv.result
                  : JSON.stringify(inv.result, null, 2)}
              </pre>
            </>
          )}
        </div>
      )}
    </div>
  );
}
